import styled from '@emotion/styled';

// ─── Sidebar Shell ───────────────────────────────────────────────────────────
export const SidebarContainer = styled.div`
  width: ${p => p.isSidebarOpen ? '240px' : '68px'};
  min-width: ${p => p.isSidebarOpen ? '240px' : '68px'};
  max-width: ${p => p.isSidebarOpen ? '240px' : '68px'};
  background: linear-gradient(180deg, ${p => p.colorPalette.bgColor1} 0%, ${p => p.colorPalette.bgColor2} 100%);
  color: ${p => p.colorPalette.fontColorSelected};
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.22s cubic-bezier(0.4, 0, 0.2, 1),
              min-width 0.22s cubic-bezier(0.4, 0, 0.2, 1),
              max-width 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.35);
  overflow: hidden;
`

// ─── Brand Header ────────────────────────────────────────────────────────────
export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 18px 16px;
  min-height: 64px;
  border-bottom: 1px solid rgba(66, 165, 245, 0.15);
  white-space: nowrap;
  overflow: hidden;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    min-width: 8px;
    border-radius: 50%;
    background: #42A5F5;
    box-shadow: 0 0 8px #42A5F5;
    margin-right: 10px;
  }

  font-family: ${p => p.font};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #E3F2FD;
  opacity: 1;
  transition: opacity 0.15s;
`

// ─── Menu Containers ─────────────────────────────────────────────────────────
export const MenuItemContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: rgba(66,165,245,0.2); border-radius: 2px; }
`

export const ItemContainer = styled.div``

// ─── Menu Item ───────────────────────────────────────────────────────────────
export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: ${p => p.isSidebarOpen ? '0 16px 0 14px' : '0'};
  justify-content: ${p => p.isSidebarOpen ? 'flex-start' : 'center'};
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  font-family: ${p => p.font};
  font-size: 14px;
  font-weight: ${p => p.selected ? '600' : '400'};
  letter-spacing: 0.3px;
  color: ${p => p.selected ? '#ffffff' : p.colorPalette.fontColor};
  background: ${p => p.selected
    ? 'linear-gradient(90deg, rgba(66,165,245,0.18) 0%, rgba(66,165,245,0.04) 100%)'
    : 'transparent'};
  border-left: 3px solid ${p => p.selected ? '#42A5F5' : 'transparent'};
  transition: all 0.18s ease;

  &:hover {
    background: ${p => p.selected
      ? 'linear-gradient(90deg, rgba(66,165,245,0.22) 0%, rgba(66,165,245,0.06) 100%)'
      : 'rgba(255,255,255,0.05)'};
    color: #ffffff;
    border-left-color: ${p => p.selected ? '#42A5F5' : 'rgba(66,165,245,0.4)'};
  }
`

export const Text = styled.span`
  display: ${p => p.isSidebarOpen ? 'inline' : 'none'};
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  margin-right: ${p => p.isSidebarOpen ? '13px' : '0'};
  transition: margin 0.22s ease;

  svg {
    font-size: 22px;
    opacity: ${p => p.selected ? '1' : '0.65'};
    color: ${p => p.selected ? '#42A5F5' : 'inherit'};
    transition: opacity 0.18s, color 0.18s;
  }
`

// ─── Submenu ─────────────────────────────────────────────────────────────────
export const SubMenuItemContainer = styled.div`
  padding: ${p => p.isSidebarOpen ? '2px 0 4px 43px' : '2px 0'};
  background: rgba(0,0,0,0.15);
  border-left: 3px solid rgba(66, 165, 245, 0.3);
`

export const SubMenuItem = styled.div`
  padding: 2px 6px 2px 2px;
  min-height: 24px;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: ${p => p.selected ? '600' : '400'};
  color: ${p => p.selected ? '#90CAF9' : 'rgba(144,202,249,0.65)'};
  letter-spacing: ${p => p.selected ? '0.5px' : 'normal'};
  cursor: pointer;
  transition: color 0.15s, padding-left 0.15s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    color: #90CAF9;
    padding-left: 16px;
  }

  &::before {
    content: '›';
    margin-right: 6px;
    opacity: ${p => p.selected ? '1' : '0.5'};
    font-size: 14px;
  }
`

// ─── Dropdown Arrow ──────────────────────────────────────────────────────────
export const DropdownIcon = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 6px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: ${p => p.isOpen ? 'none' : '5px solid rgba(144,202,249,0.7)'};
  border-bottom: ${p => p.isOpen ? '5px solid rgba(144,202,249,0.7)' : 'none'};
  transition: transform 0.25s ease;
  flex-shrink: 0;
`

// ─── User Footer ─────────────────────────────────────────────────────────────
export const UserFooter = styled.div`
  padding: 12px 16px;
  border-top: 1px solid rgba(66, 165, 245, 0.12);
  font-size: 11.5px;
  color: rgba(144, 202, 249, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    min-width: 6px;
    border-radius: 50%;
    background: #66BB6A;
    flex-shrink: 0;
  }
`

// ─── Toggler ─────────────────────────────────────────────────────────────────
export const TogglerContainer = styled.div`
  padding: 12px 0 14px;
  display: flex;
  justify-content: ${p => p.isSidebarOpen ? 'flex-end' : 'center'};
  padding-right: ${p => p.isSidebarOpen ? '18px' : '0'};
  border-top: 1px solid rgba(66, 165, 245, 0.08);
`

export const Toggler = styled.button`
  background: transparent;
  border: 1px solid rgba(66, 165, 245, 0.2);
  border-radius: 6px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  transition: border-color 0.18s, background 0.18s;

  &:hover {
    border-color: rgba(66, 165, 245, 0.5);
    background: rgba(66, 165, 245, 0.08);
  }

  &::before, &::after, span {
    content: '';
    display: block;
    width: 14px;
    height: 1.5px;
    background: rgba(144, 202, 249, 0.7);
    border-radius: 1px;
    transition: background 0.18s;
  }

  &:hover::before, &:hover::after, &:hover span {
    background: #90CAF9;
  }
`

// ─── NightShift ──────────────────────────────────────────────────────────────
export const NightShift = styled.div`
  cursor: pointer;
  position: relative;
  text-align: center;
  color: white;
  margin-top: 20px;
`
